import { NgModule } from '@angular/core';
import { LibMagnifierIconComponent } from './lib-magnifier-icon.component';

@NgModule({
  declarations: [LibMagnifierIconComponent],
  imports: [],
  exports: [LibMagnifierIconComponent],
})
export class LibMagnifierIconModule {}
